'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidAddress;

var _web3Utils = require('web3-utils');

var _isEmptyHexString = require('./isEmptyHexString');

var _isEmptyHexString2 = _interopRequireDefault(_isEmptyHexString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Given an input, return true if it is a valid address.
 *
 * @param address
 * @returns {boolean}
 */
function isValidAddress(address) {
  return typeof address === 'string' && (0, _web3Utils.isAddress)(address) && !(0, _isEmptyHexString2.default)(address);
}
//# sourceMappingURL=isValidAddress.js.map